import { NextPageWithLayout } from 'next';
import React, { ReactElement, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import LiteHomePageComponent from '@fuww/library/src/LiteHomePage';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import Head from '../components/Head';
import Hero from '../components/Hero';
import { useSiteContext } from '../components/SiteContext';
import { Link } from '../routes.mjs';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/Cgpm6B-3ebxyH2qEEIvaftI2U-JP4Q2YSvuMwJeuWFs/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLW1vYmlsZS5wbmc',
    'https://r.fashionunited.com/DpllSisaeErEvTBPvytS8G0Mt8Ax1If57PMWQopTxZc/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLW1vYmlsZS5wbmc',
    'https://r.fashionunited.com/cqblxwNxnxd2OEoQOo1wTLURTrQ3TVROaNDUWbgWKqE/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLW1vYmlsZS5wbmc',
  ],
  desktop: [
    'https://r.fashionunited.com/ZaJcutkeOAD-hPe6d4o3lU9vRKTHXzFK712FoqXvPRA/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLWRlc2t0b3AucG5n',
    'https://r.fashionunited.com/GarcokbPXY6Ds_T9rgR8XFDu6a2lDEl2IErEtyJm9O8/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLWRlc2t0b3AucG5n',
    'https://r.fashionunited.com/Zzr7YvJMGo1zZdnpQZT8_ftEC5qBQLBv5msfZ-f0-wY/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLWRlc2t0b3AucG5n',
    'https://r.fashionunited.com/rRsIASdsAaWGAM-x5Fp6vhsNg0poLjALKuIwYwx84CM/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbGl0ZS1wYWdlLWRlc2t0b3AucG5n',
  ],
};

const JobsLinkWrapper = ({ children }: { children: ReactNode }) => {
  const { locale } = useSiteContext();

  return (
    <Link
      passHref
      route={`jobs.${locale}`}
    >
      {children}
    </Link>
  );
};

const LiteHomePage: NextPageWithLayout = () => {
  const intl = useIntl();

  return (
    <>
      <Head
        title={intl.formatMessage(messages.indexTitle)}
        description={intl.formatMessage(messages.indexDescription)}
      />
      <LiteHomePageComponent
        businessIntelligenceButtonLabel={(
          intl.formatMessage(messages['info.features.businessIntelligence'])
        )}
        jobsButtonLabel={(intl.formatMessage(messages.jobs))}
        newsButtonLabel={(intl.formatMessage(messages.news))}
        content={(
          <p className="text-center my-4">
            {intl.formatMessage(messages.liteHomePageDescription)}
          </p>
        )}
        payoff="The Industry Network"
        title={intl.formatMessage(messages.indexTitle)}
        JobsLinkWrapper={JobsLinkWrapper}
      />
    </>
  );
};

LiteHomePage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Banner"
        imageUrls={headerImageUrls}
      />
  )}
  >
    {page}
  </Layout>
);

export default LiteHomePage;
